// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface EventRegistrationApiParameter extends ApiParameter {
    ProductNumber: string;
    FirstName: string;
    LastName: string;
    Title: string;
    Company: string;
    StreetAddress: string;
    Address2: string;
    Country: string;
    City: string;
    State: string;
    ZipOrPostalCode: string;
    BusinessPhone: string;
    ContactOrMobilePhone: string;
    FaxNumber: string;
    Email: string;
    HowCanWeContactYou: string;
    CommentsAndSpecialRequests: string;
    PaymentMethod: string;
    POOrReferenceNumber: string;
}

export interface EventRegistrationResult extends BaseModel {}

const trainingRegistrationUrl = "api/mcmc/trainingRegistration";

export async function sendEventRegistrationRequest(parameter: EventRegistrationApiParameter) {
    const results = await post<EventRegistrationApiParameter, EventRegistrationResult>(
        trainingRegistrationUrl,
        parameter,
    );
    return results;
}
